import { render, staticRenderFns } from "./NewTempCustomer.vue?vue&type=template&id=51e231eb"
import script from "./NewTempCustomer.vue?vue&type=script&lang=js"
export * from "./NewTempCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports